// Mock data for Leadeverest site

export const markets = [
  { code: 'HU', flag: '🇭🇺', name: 'Magyarország' },
  { code: 'SK', flag: '🇸🇰', name: 'Szlovákia' },
  { code: 'CZ', flag: '🇨🇿', name: 'Csehország' },
  { code: 'AT', flag: '🇦🇹', name: 'Ausztria' },
];

export const serviceCards = [
  { title: 'Cégadatbázis országonként', tag: 'HU · SK · CZ · AT' },
  { title: 'Időpontszervezés', tag: null },
  { title: 'Hideghívás', tag: null },
  { title: 'Telemarketing', tag: null },
  { title: 'Munkatárs biztosítása', tag: null },
  { title: 'Terjeszkedés', tag: 'HU · SK · CZ · AT' },
  { title: 'Branding', tag: null },
  { title: 'Marketing', tag: null },
  { title: 'Social Media', tag: null },
];

export const processSteps = [
  { num: '01', title: 'Cégadatbázis HU / SK / CZ / AT', desc: 'Céglista szűrőkkel és elérhetőségekkel.' },
  { num: '02', title: 'E-mail marketing', desc: 'Tömeges e-mail küldése + időpontfoglalási CTA + riport.' },
  { num: '03', title: 'Telefonos megkeresések', desc: 'Hideghívások, telemarketing HU/SK/CZ/EN/DE nyelveken.' },
  { num: '04', title: 'Munkatárs biztosítása', desc: 'Rövid és hosszútávú értékesítési erőforrás igény szerint HU/SK/CZ/EN/DE nyelveken rendszerünk használatával + meglévő ügyfélgondozás.' },
  { num: '05', title: 'Marketing + PPC', desc: 'Branding, videók, kreatívok, arculat, promó anyagok, névjegykártya, social media kampánytervezés és futtatás.' },
  { num: '06', title: 'Terjeszkedés támogatása (HU/SK/CZ/AT)', desc: 'Piackutatás, cégalapítás, bankszámla, egyéb ügyintézés.' },
  { num: '07', title: 'Havi riport készítése', desc: 'Státuszok, KPI-k, következő lépések, rendszeres összefoglaló.' },
];

export const stats = [
  { value: '2023', label: 'Alapítva Pozsonyban' },
  { value: '50+', label: 'Aktív partner' },
  { value: '4', label: 'Piac · HU / SK / CZ / AT' },
  { value: '5', label: 'Nyelv · HU / SK / CZ / EN / DE' },
];

export const principles = [
  {
    title: 'Adatvezérelt sales',
    desc: 'Saját, országonként strukturált cégadatbázisunkból építünk mérhető pipeline-t — nem sejtésből dolgozunk.',
    icon: 'Database',
  },
  {
    title: 'Mérhető eredmények',
    desc: 'Heti státusz, KPI-k, riportok — mindig tudja, hol tart a folyamat és mi a következő lépés.',
    icon: 'LineChart',
  },
  {
    title: 'Emberi kapcsolatok',
    desc: 'A bizalom, a korrekt kommunikáció és a következetes utánkövetés erősebb, mint bármilyen trükk.',
    icon: 'Handshake',
  },
  {
    title: 'Többnyelvű működés',
    desc: 'Magyar, szlovák, cseh, angol és német nyelven képviseljük ügyfeleinket, határokon átívelően.',
    icon: 'Languages',
  },
];

export const teamMedia = [
  {
    img: 'https://static.wixstatic.com/media/f901ad_b3599b517c1b4ee9b1faead4d9b54863~mv2.jpg/v1/fill/w_600,h_800,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/f901ad_b3599b517c1b4ee9b1faead4d9b54863~mv2.jpg',
    langs: 'HU · SK · CZ · EN',
    email: 'antonia@leadeverest.eu',
    phone: '+421 917 705 884',
  },
  {
    img: 'https://static.wixstatic.com/media/f901ad_78ff97dac635487f988df99f7352ade8~mv2.png/v1/fill/w_600,h_1050,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/f901ad_78ff97dac635487f988df99f7352ade8~mv2.png',
    langs: 'HU · EN',
    email: 'antal@leadeverest.eu',
    phone: '+36 70 369 3173',
  },
];

export const testimonialLogos = [
  'https://customer-assets-cm19k8pv.emergentagent.net/job_shark-modern/artifacts/huqz4kk8_whc_hu_logo-removebg-preview.png',
  'https://customer-assets-cm19k8pv.emergentagent.net/job_shark-modern/artifacts/s7eygdms_g178-removebg-preview.png',
  'https://customer-assets-cm19k8pv.emergentagent.net/job_shark-modern/artifacts/fdae9r3r_images__1_-removebg-preview.png',
];

export const situations = [
  'Jó a termékem/szolgáltatásom, de több ügyfelet szeretnék.',
  'Terjeszkedni szeretnék egy másik országban.',
  'Kell egy profi marketinges.',
  'Nem látok rá a fizetett kollégám munkájára: hány céget hívtunk fel?',
  'Új munkatársra lenne szükségem.',
  'Döntéshozókat szeretnék elérni, nem általános kontaktokat.',
  'Nincs időm napi szinten keresgélni és hívogatni.',
  'Megoldásokat akarok, nem mellébeszédet.',
  'Keveset foglalkozom a meglévő ügyfeleimmel.',
];

export const testimonials = [
  {
    company: 'WHC SLOVAKIA',
    role: 'CEO',
    logo: 'https://customer-assets-cm19k8pv.emergentagent.net/job_shark-modern/artifacts/huqz4kk8_whc_hu_logo-removebg-preview.png',
    quote: 'Kiemelten értékeljük a csapat hozzáállását, pontosságát és azt, hogy valódi üzleti eredményekben gondolkodnak. A Leadeverest olyan partner, akire egy növekedésorientált vállalat bátran rábízhatja az értékesítési folyamatainak egy részét vagy egészét.',
  },
  {
    company: 'iNTRETECH',
    role: 'CEO',
    logo: 'https://customer-assets-cm19k8pv.emergentagent.net/job_shark-modern/artifacts/s7eygdms_g178-removebg-preview.png',
    quote: 'Antallal és Antóniával való együttműködés során egy olyan partnerre találtunk, amely valódi értéket teremt az értékesítési folyamatainkban. A megkeresések minősége, a riportálás átláthatósága és a csapat szakmai felkészültsége megerősítette bennünk, hogy az adatvezérelt sales ma már elengedhetetlen.',
  },
  {
    company: 'MOTIM ZRT.',
    role: 'CEO',
    logo: 'https://customer-assets-cm19k8pv.emergentagent.net/job_shark-modern/artifacts/fdae9r3r_images__1_-removebg-preview.png',
    quote: 'A Leadeverest csapatával gyorsan világossá vált, hogy nem egyszerű szolgáltatót választottunk, hanem valódi stratégiai partnert. A rendszerük átlátható, a kommunikációjuk professzionális, és minden tevékenységük mérhető. A Leadeverest konkrét, számonkérhető eredményeket szállít – ezért dolgozunk velük.',
  },
];

export const databaseStats = [
  { flag: '🇭🇺', label: 'cég', value: '16 000', country: 'Magyarország' },
  { flag: '🇸🇰', label: 'cég', value: '13 000', country: 'Szlovákia' },
  { flag: '🇦🇹', label: 'cég', value: '47 000', country: 'Ausztria' },
  { flag: '🇨🇿', label: 'cég', value: '3 000', country: 'Csehország' },
];

export const emailSteps = [
  { num: '01', title: 'Célcsoport kiválasztása a cégadatbázisból', desc: 'Szűrés iparág, régió, cégméret.' },
  { num: '02', title: 'Tömeges e-mail sorozatok', desc: 'Hírlevél, bemutatkozó, ajánlati üzenetek, ütemezett utánkövetéssel, leiratkozási lehetőséggel.' },
  { num: '03', title: 'Beépített időpontfoglalás (CTA)', desc: 'A címzett 1 kattintással 15 perces egyeztetést foglal, a rendszer automatikusan rögzíti az eseményt és a naptárba teszi.' },
  { num: '04', title: 'Valós idejű tracking és riport', desc: 'Kézbesítés, megnyitás, kattintás, válasz, időpontfoglalás — kampányonként és címzettenként is visszamérhető.' },
  { num: '05', title: 'Az Ön céges e-mail címéről', desc: 'Az e-mail sorozatokat az Ön vállalati e-mail címéről küldjük ki, így Ön is közvetlenül nyomon tudja követni a kiküldéseket, a válaszokat és az egyeztetések alakulását.' },
];

export const phoneServices = [
  { title: 'Hideg hívások', desc: 'Adatbázisból keressük a cégeket, felépített beszélgetési vázlattal.' },
  { title: 'Felmelegített hívások', desc: 'Azokat is hívjuk, akik az e-mail kampányban aktivitást mutattak.' },
  { title: 'Időpont szervezés', desc: 'Célunk elérni a döntéshozót, időpontot szervezni az értékesítőnek.' },
  { title: 'Telemarketing', desc: 'Betanulás és telefonos értékesítés + riport.' },
  { title: 'Többnyelvű megkeresés', desc: 'A hívásokat és az utánkövetést magyar, szlovák, cseh, angol és német nyelven is vállaljuk.' },
  { title: 'Átadás és dokumentálás', desc: 'Kivel mi volt, mi hangzott el, mi az igény, mi a következő lépés, egyeztetett időpont, vagy elutasítás.' },
];

export const staffServices = [
  { title: 'Sales, telefonos értékesítő, ügyintéző vagy koordinátor munkaerő biztosítása', desc: 'Önéletrajzokból választható alkalmi vagy hosszútávú partner, aki a megbízó cég „arca” és az Ön cége nevében kommunikál HU / SK / CZ / EN / DE nyelveken.' },
  { title: 'Rendszer', desc: 'A munkatárs a mi workflow-unkat használja (státuszok, utánkövetés, meeting brief, riportok).' },
  { title: 'Teljes eszközbiztosítás igény esetén', desc: 'Céges autó, telefon és laptop biztosítása, hogy a munkavégzés azonnal, professzionális szinten indulhasson.' },
  { title: 'Onboarding és betanítás', desc: 'Felkészítés a termékre, célpiacra.' },
  { title: 'Szakmai felügyelet', desc: 'Vezetés és minőségellenőrzés, heti státusz/riport készítése + pipeline, hogy mindig lássuk, hol tartunk.' },
];

export const marketingServices = [
  { title: 'Branding', desc: 'Arculat és logo tervezés.' },
  { title: 'Kreatív gyártás', desc: 'Professzionális képek, videók, grafikai anyagok, animációk, több nyelven is.' },
  { title: 'Sales anyagok', desc: 'Prezentációk, ajánlati anyagok, one-pager, névjegykártya, promóciós anyagok.' },
  { title: 'Online hirdetések (PPC)', desc: 'Kampánytervezés, beállítás, folyamatos optimalizálás (FB/IG/Google).' },
  { title: 'Közösségi média tartalom és kampányok', desc: 'Posztok, hirdetések.' },
  { title: 'Mérés és riportálás', desc: 'KPI-k követése, tanulságok, finomhangolás és skálázás.' },
];

export const expansionSteps = [
  { num: '01', title: 'Piackutatás és célpiac-kijelölés', desc: 'Országonkénti fókusz (iparág, cégméret, régió, versenykörnyezet).' },
  { num: '02', title: 'Belépési stratégia és ütemezés', desc: 'Kinek adunk el, milyen ajánlattal, mely csatornákon, milyen lépésekben.' },
  { num: '03', title: 'Célzott céglista és döntéshozói elérhetőségek', desc: 'Az adott országban, saját adatbázisunkra építve (HU / SK / CZ / AT).' },
  { num: '04', title: 'Piacnyitó outreach kampányok', desc: 'Szegmentált bemutatkozó e-mailek + több lépéses utánkövetés.' },
  { num: '05', title: 'Többnyelvű telefonos megkeresés és időpontszervezés', desc: 'HU / SK / CZ / EN / DE nyelveken, minősített meetingekkel.' },
  { num: '06', title: 'Személyes képviselet', desc: 'Alkalmi projektek és hosszútávú projektek egyaránt.' },
  { num: '07', title: 'Riportálás és optimalizálás', desc: 'Eredmények mérése, finomhangolás, skálázás a legjobban működő szegmensekre.' },
  { num: '08', title: 'Opcionális: Cégalapítás, fordítás, bankszámlanyitás, egyéb ügyintézés', desc: 'Gyakorlati segítség az induláshoz és működéshez.' },
];

export const offices = [
  { flag: '🇭🇺', label: 'HU', address: '2900 Komárom' },
  { flag: '🇸🇰', label: 'SK', address: '811 01 Bratislava' },
  { flag: '🇭🇺', label: 'HU', address: '9200 Mosonmagyaróvár' },
  { flag: '🇸🇰', label: 'SK', address: '943 01 Dunaszerdahely' },
];

export const CTA_URL = 'https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0bOCZiN1gXvwS-EOuOJBO_8b4GrA60viB9m0v2OBsCHLCP_bwnKVcNw6uOxyIPUBXSWag87WS3';

// Video assets from the reference site
export const heroVideo = {
  src: '/hero.mp4',
  poster: '',
};

export const goalVideo = {
  webm: '/svc/goal.webm',
  mp4: '/svc/goal.mp4',
};

export const servicesHeroVideo = {
  webm: '/svc/hero.webm',
  mp4: '/svc/hero.mp4',
};

// Portrait videos for each service section (in order matching services)
export const serviceVideos = {
  cegadatbazis: { webm: '/svc/cegdb.webm', mp4: '/svc/cegdb.mp4' },
  email: { webm: '/svc/email.webm', mp4: '/svc/email.mp4' },
  phone: { webm: '/svc/phone.webm', mp4: '/svc/phone.mp4' },
  staff: { webm: '/svc/staff.webm', mp4: '/svc/staff.mp4' },
  marketing: { webm: '/svc/mark.webm', mp4: '/svc/mark.mp4' },
  expansion: { webm: '/svc/exp.webm', mp4: '/svc/exp.mp4' },
};
